
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, moduleTypeNames } from "../../../framework/core/mvvm/module_base";
import ClubMemberPopView from "./club_member_pop_view";



const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("ClubMemberPopModule")
export default class ClubMemberPopModule extends ModuleBase<ClubMemberPopView,null> {


    private data : any[];

    private index : number;

    constructor(){
        super();

        this.layer = ViewLayer.Mid;
        this.modelType = null;
        this.viewType = ClubMemberPopView;
        this.needViewMask = true
        this.clickAnywhereClose = false;
        this.windowPrefabResPath = "package/club/module/club_member_pop"
        
    }

    @bindButtonClickEvent("confirm")
    onConfirm(){

        this.hide();

        this.eventDispatch("club_request_set_currency",this.index,this.view.setEditor.string);
        
        console.log("onConfirm");
    }

    @bindButtonClickEvent("close")
    onClose(){
        this.hide();
    }

    onShow(intentData:any){
         
        console.log(" index " , intentData.index);

        this.index = intentData.index;
        
        this.data = intentData.data;

        this.view.updateInfo(this.data);
    }

  
}
